const rootConst = 'MERCHANT';

export const GET_MERCHANT_PROFILE = `${rootConst}/GET_MERCHANT_PROFILE`;
